import React, { Component } from "react";
import LoadingBlock from "../components/common/LoadingBlock";

export default class LoadingWrapper extends Component {
  constructor() {
    super();

    this.state = {
      loading: true
    };
  }

  endLoading = () => {
    this.setState({ loading: false });
  };

  render() {
    if (this.state.loading) return <LoadingBlock purchase={false} />;
    return this.props.children(this.state, this.endLoading);
  }
}
// export default class RecommendationsFetcher extends Component {
//   //Do all the data fetching required in the Recommendations Component
//   constructor() {
//     super();

//     this.state = {
//       loading: true,
//       recommendedProducts: []
//     };

//     //Private Variables
//     this.userId = localStorage.getItem("user_id");
//     this.authToken = localStorage.getItem("auth_token");
//   }

//   componentDidMount() {
//     this.fetchRecommendedProducts();
//   }
//   //Fetch RecommendedProducts
//   fetchRecommendedProducts = () => {
//     const url = "/api/surveys/result?user-id=";
//     // this.props.additional
//     //   ? "/api/surveys/extra-recommendation?user-id="

//     fetch(url + this.userId, {
//       method: "GET",
//       headers: {
//         Accept: "application/json",
//         "Content-Type": "application/json",
//         "x-auth-token": this.authToken
//       }
//     })
//       .then(response => response.json())
//       .then(responseJson => {
//         this.setState({
//           recommendedProducts: responseJson.recommendedProducts,
//           loading: false
//         });
//       })
//       .catch(function(err) {
//         console.log(err);
//       });
//   };

//   render() {
//     if (this.state.loading) return <LoadingBlock purchase={false} />;
//     // return () => {
//     return this.props.render(this.state);
//     // };
//   }
// }

/*** ADDITIONAL RECOMMENDATIONS ***/
// getAdditionalRecommendations() {
// 	const userId = localStorage.getItem("user_id");
// 	fetch('/api/surveys/extra-recommendation?user-id=' + userId, {
// 			method: 'GET',
// 			headers: {
// 					'Accept': 'application/json',
// 					'Content-Type': 'application/json',
// 					'x-auth-token': localStorage.getItem("auth_token")
// 			}
// 	})
// 	.then((response) => response.json())
// 	.then(responseJson => {
// 			this.setState({
// 					additionalRecommendedProducts: responseJson
// 			});
// 	})
// 	.catch(function(err) {
// 			alert("There was a problem to getting your additional recommendations. Please try again.");
// 	});
// }

// checkIfPaidGateFee() {
// 	const userId = localStorage.getItem("user_id");
// 	fetch('/api/user-flags/gate-fee-paid?user-id=' + userId, {
// 			method: 'GET',
// 			headers: {
// 					'Accept': 'application/json',
// 					'Content-Type': 'application/json',
// 					'x-auth-token': localStorage.getItem("auth_token")
// 			}
// 	})
// 	.then((response) => response.json()).then(responseJson => {
// 			if (responseJson) {
// 					this.getAmountPaidGateFee();
// 					this.setState({ userPaidGateFee: true });
// 			}
// 	})
// 	.catch(function(err) {
// 			alert("There was a problem getting the confirmation code. Please try again.");
// 	});
// }

// defaultPurchaseStatus(status) {
// 	this.setState({ defaultPurchaseStatus: status });
// }

// selectProduct(product) {
// 	this.setState({
// 			openModal: true,
// 			product: product
// 	});
// }

//  /*** DEFAULT PURCHASE API CALLS ***/
//  checkIfCardIsOnStripe() {
// 	const userId = localStorage.getItem("user_id");
// 	fetch('/api/stripe-customers/status?user-id=' + userId, {
// 			method: 'GET',
// 			headers: {
// 					'Accept': 'application/json',
// 					'Content-Type': 'application/json',
// 					'x-auth-token': localStorage.getItem("auth_token")
// 			}
// 	})
// 	.then(response => response.json())
// 	.then(responseJson => {
// 			if (responseJson) {
// 					this.checkDefaultPurchaseStatus();
// 			} else {
// 					return;
// 			}
// 	})
// 	.catch(err => {
// 			alert('There was a problem checking for eligibility: ' + err);
// 	});
// }

// //Start Default Purchase Timer
// startTimerOptIn() {
// 	const userId = localStorage.getItem("user_id");
// 	fetch('/api/default-purchases/start?user-id=' + userId, {
// 			method: 'POST',
// 			headers: {
// 					'Accept': 'application/json',
// 					'Content-Type': 'application/json',
// 					'x-auth-token': localStorage.getItem("auth_token")
// 			}
// 	})
// 	.then((response) => {
// 			if (response.status === RESPONSE_STATUS.OK) {
// 					fetch('/api/default-purchases?user-id=' + userId, {
// 							method: 'GET',
// 							headers: {
// 									'Accept': 'application/json',
// 									'Content-Type': 'application/json',
// 									'x-auth-token': localStorage.getItem("auth_token")
// 							}
// 					})
// 					.then(response => response.json())
// 					.then(responseJson => {
// 							this.setState({
// 									defaultPurchaseStartTime: responseJson.createdDate,
// 									defaultPurchaseStarted: true,
// 									runTutorial: true
// 							}, () => {
// 									this.props.defaultPurchaseStatus("started");
// 									const url = 'https://hooks.zapier.com/hooks/catch/2569749/0z8ws2/';
// 									fetch(url, {
// 											method: 'POST',
// 											body: JSON.stringify({
// 													"First Name": this.props.firstName,
// 													"Last Name": this.props.lastName,
// 													"Phone": this.props.userPhone,
// 													"Email": this.props.userEmail
// 											})
// 									})
// 									.catch(function(err) {
// 											alert("There was a sending your status. Please try again.");
// 									});
// 							});
// 					})
// 					.catch(err => {
// 							alert('There was a problem starting the  timer: ' + err);
// 					});
// 			}
// 	})
// 	.catch(err => {
// 			alert('There was a problem starting the default purchase process: ' + err);
// 	});

// }

// getAmountPaidGateFee() {
// 	const userId = localStorage.getItem("user_id");
// 	const url = '/api/gate-fees?user-id=' + userId;
// 	fetch(url, {
// 			method: 'GET',
// 			headers: {
// 					'Accept': 'application/json',
// 					'Content-Type': 'application/json',
// 					'x-auth-token': localStorage.getItem("auth_token")
// 			}
// 	}).then((response) => {
// 			if (response.status >= 200 && response.status < 300) {
// 					let contentLength = parseInt(response.headers.get("content-length"), 10);
// 					if (contentLength === 0) {
// 							return null;
// 					} else {
// 							return response.json();
// 					}
// 			} else {
// 					this.setState({ amountPaidGateFee: 10 });
// 			}
// 	}).then(responseJson => {
// 			if ((responseJson === null || responseJson === undefined) || (responseJson && responseJson.length < 1)) {
// 					this.setState({ amountPaidGateFee: 10 });
// 			} else {
// 					this.setState({ amountPaidGateFee: responseJson.amount });
// 			}
// 	}).catch(function(err) {
// 			console.log("resp");
// 	});
// }

// handleOptOut() {
// 	const userId = localStorage.getItem("user_id");
// 	fetch('/api/default-purchases/opt-out?user-id=' + userId, {
// 			method: 'POST',
// 			headers: {
// 					'Accept': 'application/json',
// 					'Content-Type': 'application/json',
// 					'x-auth-token': localStorage.getItem("auth_token")
// 			}
// 	})
// 	.then(response => {
// 			if (response.status === RESPONSE_STATUS.OK || (response.status >= 200 && response.status < 300)) {
// 					this.setState({ defaultPurchaseStarted: false, defaultPurchaseComplete: false, openCancelModal: false }, () => {
// 							this.props.defaultPurchaseStatus("opt-out");
// 							const url = 'https://hooks.zapier.com/hooks/catch/2569749/0yrokb/';
// 							/* const url = 'https://hooks.zapier.com/hooks/catch/2569749/oo5yzaj/'; */
// 							const date = new Date();
// 							const phone = "+1 " + this.formatPhoneNumber(this.props.userPhone);
// 							fetch(url, {
// 									method: 'POST',
// 									body: JSON.stringify({
// 											"fields": {
// 													"First Name": this.props.firstName,
// 													"Last Name": this.props.lastName,
// 													"Phone": phone,
// 													"Timestamp": util.convertToStandardTime(date.getTime() / 1000),
// 													"Email": this.props.userEmail
// 											}
// 									})
// 							})
// 							.catch(function(err) {
// 									alert("There was a problem opting out. Please try again.");
// 							});
// 					});
// 			} else {
// 					throw new Error("Server response error.")
// 			}
// 	})
// 	.catch(err => {
// 			alert('There was a problem opting out of your purchase: ' + err);
// 	});

// }

// formatPhoneNumber(phoneNumberString) {
// 	let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
// 	let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
// 	if (match) {
// 			return '(' + match[1] + ') ' + match[2] + '-' + match[3];
// 	}
// 	return null;
// }

/*** END DEFAULT PURCHASE ***/



// WEBPACK FOOTER //
// ./src/hocs/RecommendationsFetcher.js